import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ImageconfigService } from "../../services/imageconfig.service";
import { BrandingService, BrandConfig } from "../../services/branding.service";
import { MenuService } from "../../services/menu.service";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { AppSettings } from "src/app/config/AppSettings";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  username: { type: String };
  password: { type: String };
  userId: String = "";
  hideinvlidloginmsg: boolean = true;
  loginerrormsg: string = "";
  forgeterrormsg: string = "";
  closeResult: string;
  returntest: string = "";
  brandLogo: string = "assets/images/Roadgrid.png";
  brandLogoBg: string = "transparent";
  brandName: string = "RoadGrid";
  brandTitle: string = "RoadGrid CMS";
  brandSlug: string = "";
  isInvalidUrl: boolean = false;

  get isRoadgrid(): boolean {
    return !this.brandLogo || this.brandLogo.toLowerCase().includes("roadgrid");
  }

  private loginfooter: any;
  constructor(
    private authService: AuthService,
    private router: Router,
    public imagePath: ImageconfigService,
    private modalService: NgbModal,
    private menuservice: MenuService,
    private route: ActivatedRoute,
    private appsettings: AppSettings,
    private brandingService: BrandingService
  ) {
    this.hideinvlidloginmsg = true;
    this.loginerrormsg = "";
    this.forgeterrormsg = "";
    this.loginfooter = appsettings.get("copyright-text");

    // Immediately resolve brand from URL hash without waiting for async router events
    const rawHash = (window.location.hash || "").replace(/^#\/?/, "").split("?")[0].trim().toLowerCase();
    const segments = rawHash.split("/").filter(s => !!s);
    let potentialSlug = "";
    if (segments.length === 1 && segments[0] !== "login" && segments[0] !== "home") {
      potentialSlug = segments[0];
    } else if (segments.length >= 2 && segments[0] === "login") {
      potentialSlug = segments[1];
    }

    if (potentialSlug) {
      if (this.brandingService.isValidBrand(potentialSlug)) {
        const brandConfig = this.brandingService.getBrand(potentialSlug);
        if (brandConfig) {
          this.brandLogo = brandConfig.logo;
          this.brandLogoBg = brandConfig.logoBg || "rgb(2, 2, 124)";
          this.brandName = brandConfig.name;
          this.brandTitle = brandConfig.loginTitle;
          this.brandSlug = potentialSlug;
          this.isInvalidUrl = false;
        } else {
          this.isInvalidUrl = true;
        }
      } else {
        this.isInvalidUrl = true;
      }
    }
  }
  onLoginSubmit() {
    const currentBrand = this.brandSlug || localStorage.getItem("brand") || sessionStorage.getItem("brand") || "";
    const currentLogo = this.brandLogo || localStorage.getItem("brandLogo") || sessionStorage.getItem("brandLogo") || "assets/images/Roadgrid.png";
    const currentLogoBg = this.brandLogoBg || localStorage.getItem("brandLogoBg") || sessionStorage.getItem("brandLogoBg") || "transparent";

    if (currentBrand) {
      sessionStorage.setItem("brand", currentBrand);
      localStorage.setItem("brand", currentBrand);
    }
    sessionStorage.setItem("brandLogo", currentLogo);
    localStorage.setItem("brandLogo", currentLogo);
    sessionStorage.setItem("brandLogoBg", currentLogoBg);
    localStorage.setItem("brandLogoBg", currentLogoBg);

    const user = {
      username: this.username,
      password: this.password
    };
    this.authService.authenticateUser(user).subscribe(
      data => {
        if (data.success) {
          // Re-persist brand into storage immediately
          if (currentBrand) {
            sessionStorage.setItem("brand", currentBrand);
            localStorage.setItem("brand", currentBrand);
          }
          sessionStorage.setItem("brandLogo", currentLogo);
          localStorage.setItem("brandLogo", currentLogo);
          sessionStorage.setItem("brandLogoBg", currentLogoBg);
          localStorage.setItem("brandLogoBg", currentLogoBg);

          const navigateToMain = () => {
            this.hideinvlidloginmsg = true;
            this.loginerrormsg = "";
            const target = (this.returntest === "/main/logs") ? "main/logs" : "main";
            this.router.navigate([target]).then(navSuccess => {
              if (!navSuccess) {
                console.warn("Navigation to " + target + " was prevented. Forcing navigateByUrl...");
                this.router.navigateByUrl("/" + target);
              }
            });
          };

          this.authService.loadPrivileges()
            .then(() => this.menuservice.loadMenus())
            .then(() => navigateToMain())
            .catch(err => {
              console.warn("Error loading privileges or menus:", err);
              navigateToMain();
            });
        } else {
          this.hideinvlidloginmsg = false;
          if (data.message == "INVALIDUSER") {
            this.loginerrormsg = "User name is not correct!";
          } else if (data.message == "AUTHFAILED") {
            this.loginerrormsg = "Authentication failed!";
          } else {
            this.loginerrormsg = "Error in login!";
          }
        }
      },
      err => {
        this.hideinvlidloginmsg = true;
        this.loginerrormsg = "Error in login!";
      }
    );
  }
  ngOnInit() {
    this.route.queryParams.subscribe(
      params => (this.returntest = params["returnUrl"] || "/forums")
    );

    // Read brand slug from URL (e.g., /nexusvivita, /login/nexusvivita)
    this.route.params.subscribe(params => {
      const brandSlug = params["brand"];
      if (brandSlug) {
        if (!this.brandingService.isValidBrand(brandSlug)) {
          this.isInvalidUrl = true;
          return;
        }
        const brandConfig = this.brandingService.getBrand(brandSlug);
        if (!brandConfig) {
          this.isInvalidUrl = true;
          return;
        }
        this.isInvalidUrl = false;
        this.brandSlug = brandSlug;
        this.brandLogo = brandConfig.logo;
        this.brandLogoBg = brandConfig.logoBg || (this.isRoadgrid ? "transparent" : "rgb(2, 2, 124)");
        this.brandName = brandConfig.name;
        this.brandTitle = brandConfig.loginTitle;
        sessionStorage.setItem("brand", brandSlug);
        localStorage.setItem("brand", brandSlug);
        sessionStorage.setItem("brandLogo", this.brandLogo);
        localStorage.setItem("brandLogo", this.brandLogo);
        sessionStorage.setItem("brandLogoBg", this.brandLogoBg);
        localStorage.setItem("brandLogoBg", this.brandLogoBg);
      } else {
        const rawHash = (window.location.hash || "").replace(/^#\/?/, "").split("?")[0].trim().toLowerCase();
        const segments = rawHash.split("/").filter(s => !!s);
        if (segments.length === 0 || segments[0] === "login" || segments[0] === "home") {
          this.isInvalidUrl = false;
          this.brandSlug = "";
          const brandConfig = this.brandingService.getDefaultBrand();
          this.brandLogo = brandConfig.logo;
          this.brandLogoBg = brandConfig.logoBg || "transparent";
          this.brandName = brandConfig.name;
          this.brandTitle = brandConfig.loginTitle;
          sessionStorage.removeItem("brand");
          localStorage.removeItem("brand");
          sessionStorage.setItem("brandLogo", this.brandLogo);
          localStorage.setItem("brandLogo", this.brandLogo);
          sessionStorage.setItem("brandLogoBg", this.brandLogoBg);
          localStorage.setItem("brandLogoBg", this.brandLogoBg);
        } else {
          this.isInvalidUrl = true;
        }
      }
    });
  }

  forgotPasswordClick(content) {
    this.userId = "";
    this.forgeterrormsg = "";
    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        result => {
          this.closeResult = `Closed with: ${result}`;
          console.log(result);
        },
        reason => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  onForgotPassword() {
    if (this.userId == "" || this.userId == null) {
      this.hideinvlidloginmsg = false;
      this.forgeterrormsg = "UserId Required";
      return false;
    } else {
      this.authService.forgotpassword(this.userId).subscribe(data => {
        alert("Mail Sent! Check Your Mail");
        this.modalService.dismissAll("Mail Sent");
      });
      this.hideinvlidloginmsg = true;
      this.forgeterrormsg = "";
    }
  }
  isLoginFooter() {
    if (
      this.loginfooter != undefined &&
      this.loginfooter["show-copyright-footer"] != undefined
    ) {
      return this.loginfooter["show-copyright-footer"];
    } else {
      return false;
    }
  }
  getfooterlink(type: string) {
    let link: string = undefined;
    if (this.loginfooter) {
      const loginfootertype = this.loginfooter[type];
      if (loginfootertype) {
        link = loginfootertype["link"];
      }
    }
    return link;
  }

  getfooterlinktext(type: string) {
    let linktext: string = undefined;
    if (this.loginfooter) {
      const loginfootertype = this.loginfooter[type];
      if (loginfootertype) {
        linktext = loginfootertype["text"];
      }
    }
    return linktext;
  }
}
